<template>
    <div class="network-inclusion-status button">
        <div v-if="isInMyNetwork"></div>
        <div v-else>
            <common-button
                :label="$t('elements.network.network_inclusion_status.buttons.add_to_my_network')"
                :isSubmittable="false"
                :size="'micro'"
                type="add-to-my-network"
                @click="addToNetworkClicked"
            ></common-button>
        </div>
    </div>
</template>

<script>
    import UsersAPI from 'api/UsersAPI'
    import UserTypeEnum from '@/enums/UserTypeEnum'

    export default {
        props: {
            isInMyNetwork: { type: Boolean, required: true },
            targetType: { type: String, required: true },
            targetId: { type: Number, required: true },
            provider: { type: Object, default: undefined },
        },
        methods: {
            addToNetworkClicked() {
                const request = {
                    toUserId: this.targetType === UserTypeEnum.PRACTICE ? null : this.provider.id,
                    toPracticeId: this.targetType === UserTypeEnum.PRACTICE ? this.provider.id : this.provider.practice.id,
                }

                UsersAPI.addToMyNetwork(this.$auth.getActiveMember().id, request).then(() =>
                    this.emitEvent({
                        name: 'added-to-network',
                        payload: { userId: request.toUserId, practiceId: request.toPracticeId },
                    }),
                )
            },
        },
    }
</script>
